var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMicrosoftDynamics = function SvgMicrosoftDynamics(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_5830)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_268_5830",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 24,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3334 10.349C27.3334 8.94034 26.4478 7.6837 25.1211 7.2099L5.78177 0.303047C4.91347 -0.00706618 4 0.636664 4 1.5587V12.0604C4 12.6239 4.35423 13.1265 4.8849 13.3161L13.5516 16.4113C14.4199 16.7214 15.3333 16.0777 15.3333 15.1556V9.12564C15.3333 8.65984 15.7989 8.3376 16.2348 8.50167L18.5074 9.35694C19.8065 9.84584 20.6667 11.0886 20.6667 12.4767V15.1026L10.8757 18.68C10.3498 18.8722 10 19.3724 10 19.9324V30.4266C10 31.3528 10.921 31.9968 11.7909 31.6789L25.144 26.7999C26.4588 26.3195 27.3333 25.0688 27.3333 23.669L27.3334 10.349Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_268_5830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 -0.333374L27.3334 7.99989V19.4415C27.3334 20.3635 26.42 21.0072 25.5517 20.6972L20.6667 18.9531V12.4747C20.6667 11.086 19.8057 9.84273 18.5057 9.35429L16.2345 8.50093C15.7986 8.33716 15.3333 8.65936 15.3333 9.12499V17.0476L4 13V-0.333374Z",
    fill: "url(#paint0_linear_268_5830)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_268_5830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 10.4666C27.3333 11.8664 26.4588 13.1195 25.144 13.5999L10 19.1333V32.4666L27.3333 26.1332V10.4666Z",
    fill: "black",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_268_5830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 10.9999C27.3333 12.3997 26.4588 13.6528 25.144 14.1332L10 19.6666V32.9999L27.3333 26.6665V10.9999Z",
    fill: "black",
    fillOpacity: 0.32
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 10.3333C27.3333 11.7331 26.4588 12.9862 25.144 13.4666L10 19V32.3333L27.3333 25.9999V10.3333Z",
    fill: "url(#paint1_linear_268_5830)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.3333 10.3333C27.3333 11.7331 26.4588 12.9862 25.144 13.4666L10 19V32.3333L27.3333 25.9999V10.3333Z",
    fill: "url(#paint2_linear_268_5830)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.6669 15.1067L15.3306 17.0589L15.3306 24.8783C15.3306 25.3441 15.7962 25.6663 16.2321 25.5022L18.5079 24.6456C19.8069 24.1566 20.6669 22.9139 20.6669 21.5259V15.1067Z",
    fill: "#B0ADFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_268_5830",
    x: 9.2,
    y: 9.66655,
    width: 18.9335,
    height: 23.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "effect1_foregroundBlur_268_5830"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_268_5830",
    x: 2,
    y: 2.99988,
    width: 33.3335,
    height: 38.0001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_268_5830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_268_5830",
    x1: 12.6817,
    y1: -0.333374,
    x2: 18.8862,
    y2: 15.9077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B53CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7252AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_268_5830",
    x1: 21.3792,
    y1: 31.164,
    x2: 21.3792,
    y2: 11.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2266E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE7FE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_268_5830",
    x1: 27.3333,
    y1: 18.9286,
    x2: 20.6921,
    y2: 18.9286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287843,
    stopColor: "#94B9FF",
    stopOpacity: 0.523646
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#538FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_5830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMicrosoftDynamics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoft-dynamics.818b653e2a1cfa4c1b798e96511e6cd5.svg";